<ng-container *ngIf="component.data$ | async as data">
  <div
    class="responsive-banner-container display-none"
    [class.hasTitle]="responsiveBannerTitle"
    [ngClass]="{
      'display-block':
        requestAccount(data['styleClass']) === 'loginLeftImage' ||
        requestAccount(data['styleClass']) === 'requestAccountLeftImage' ||
        this.isRedirect ||
        (isResetPasswordPage$ | async)
    }"
  >
    <cx-media
      *ngIf="isDesktop && data.media"
      [container]="data?.media['desktop']"
      [class.hasTitle]="responsiveBannerTitle"
      class="responsive-desktop"
      [ngClass]="activeCountry$ | async"
    ></cx-media>
    <cx-media
      *ngIf="!isDesktop && !isMobile && data.media"
      [container]="data?.media['tablet']"
      [class.hasTitle]="responsiveBannerTitle"
      [ngClass]="linesOfBannerName()"
      class="responsive-tablet"
      [ngClass]="activeCountry$ | async"
    ></cx-media>
    <cx-media
      *ngIf="isMobile && data.media"
      [container]="data?.media['mobile']"
      [class.hasTitle]="responsiveBannerTitle"
      class="responsive-mobile"
      [ngClass]="linesOfBannerName()"
      [ngClass]="activeCountry$ | async"
    ></cx-media>
    <div
      class="d-flex align-self-center text"
      [class.pos-rel]="
        !((isDesktop && data.media) || (!isDesktop && !isMobile && data.media) || (isMobile && data.media))
      "
      *ngIf="responsiveBannerTitle"
    >
      <h1 *ngIf="(responsiveBannerTitle | json) != '{}'">{{ responsiveBannerTitle }}</h1>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="myaccount">
  <div class="myaccount-banner-info">
    <div class="myaccount-title">
      <p id="banner" class="myaccount-banner-name">
        {{ myaccount?.name }}
      </p>
    </div>
    <div class="main-wrapper">
      <div class="myaccount-banner-content">
        <div class="myaccount-customer-service">
          <p class="myaccount-label">{{ myaccount.customerNumberLabel }}</p>
          <p class="myaccount-info">{{ myaccount?.uid }}</p>
        </div>
        <div class="myaccount-customer-registration" *ngIf="showVatNumber$ | async">
          <p class="myaccount-label">
            {{ myaccount.customerRegistrationNumberLabel }}
          </p>
          <p class="myaccount-info">{{ myaccount?.ilnID }}</p>
        </div>
      </div>
      <div class="myaccount-banner-dealership">
        <p class="myaccount-label">{{ myaccount.dealershipTypeLabel }}</p>
        <p class="myaccount-dealership">
          <span class="myaccount-info" *ngFor="let dealership of myaccount.dealershipTypes.enums; let last = last">
            <ng-container *ngIf="!last; else lastItem">{{ dealership?.name }}, </ng-container>
            <ng-template #lastItem>{{ dealership?.name }}</ng-template>
          </span>
        </p>
      </div>
    </div>
  </div>
</ng-container>
